import React from 'react';
import { Text, View } from '@coinscrap/webapp-core';

import { DashedLines } from 'components/DashedLines/DashedLines';

export const SectionSubTitle = ({ title, style, tooltip = false }) => {
	return (
		<View alignItemsStartSt style={style}>
			<View rowSt justifyStartSt>
				<Text headingSubtitleSt>{title}</Text> {tooltip}
			</View>
		</View>
	);
};
